import React, { useState, useEffect } from 'react';
import {
    Container,
    Grid,
    Typography,
    Paper,
    Button,
    InputLabel,
    MenuItem,
    FormControl,
    Select,
    Box,
    IconButton,
    InputAdornment,
} from '@mui/material';
import TextField from '@mui/material/TextField';
import { red } from '@mui/material/colors'
import { Add, Remove } from '@mui/icons-material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { styled } from '@mui/material/styles';
import SaveIcon from '@mui/icons-material/Save';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import dayjs from 'dayjs';

import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import { LoadingButton } from '@mui/lab';

import {
    MoneyTextMask,
    MoneyTextMask4,
    ContractNumberMask
} from '../../components/masks';

import { api } from '../../services/api';

import { getUserId } from '../../services/auth';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={10} ref={ref} variant="filled" {...props} />;
});

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const createNewAcc = async item => {
    const formData = new FormData();
    for (let i = 0; i < item.arquivos.length; i++) {
        if (item.arquivos[i]["file"] !== "" && item.arquivos[i]["field"] !== "") {
            formData.append(item.arquivos[i]["field"], item.arquivos[i]["file"]);
        }
    }
    const newItem = { ...item };
    newItem.taxaCambial = realToFloat(newItem.taxaCambial);
    newItem.taxaJuros = realToFloat(newItem.taxaJuros);
    newItem.valorMonetarioDolar = realToFloat(newItem.valorMonetarioDolar);
    newItem.usuario = getUserId();
    const jsonBody = JSON.stringify(newItem);
    const blob = new Blob([jsonBody], {
        type: 'application/json'
    });
    formData.append("body", blob);
    const resp = await api.postAcc(formData);
    return resp;
}

function realToFloat(value) {
    let newValue = value.replace(/\./g, "");
    newValue = newValue.replace(",", ".");
    return parseFloat(newValue);
}

export default function AccCreate() {
    const base = {
        "contaDeposito": "",
        "naturezaOperacao": "",
        "dataContrato": null,
        "dataCredito": null,
        "dataLiquidacaoContrato": null,
        "codigoMoeda": "",
        "valorMonetarioDolar": "",
        "valorMonetarioReal": "",
        "codigoEntregaMoeda": "",
        "contratoBacen": "",
        "contratoBanco": "",
        "taxaJuros": "",
        "taxaCambial": "",
        "emailFinanceiro": "",
        "emailContabil": "",
        "banco": "",
        "exportadora": "",
        "arquivos": []
    }

    const [inputFields, setInputFields] = useState(base);

    const [running, setRunning] = useState(false);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [severity, setSeverity] = useState("success");

    const [exporterList, setExporterList] = useState([]);
    // const [userList, setUserList] = useState([]);
    const [bankList, setBankList] = useState([]);

    const today = dayjs();
    const todayStartOfTheDay = today.startOf('day');

    useEffect(() => {
        let mounted = true;
        api.getExporters()
            .then(resp => {
                if (mounted && resp) {
                    if (resp.length === 1) {
                        setInputFields({ ...inputFields, exportadora: resp[0].id });
                    }
                    setExporterList(resp);
                }
            })
        // api.getUsers()
        //     .then(resp => {
        //         if (mounted && resp) {
        //             setUserList(resp);
        //         }
        //     })
        api.getFinInstitutions()
            .then(resp => {
                if (mounted && resp) {
                    setBankList(resp);
                }
            })
        return () => {
            mounted = false;
            setInputFields(base);
        }
    }, [])

    const handleSubmit = async e => {
        setRunning(true);
        e.preventDefault();
        const resp = await createNewAcc(inputFields);
        if (resp) {
            setMessage("Contrato cadastrado com sucesso!");
            setSeverity("success");
            setInputFields(base);
        } else {
            setMessage("Erro ao cadastrar novo contrato!");
            setSeverity("error");
        }
        setOpen(true);
    }

    const handleClose = (event, reason) => {
        setRunning(false);
        setOpen(false);
    };

    const handleAddFile = (target, idx) => {
        let filesList = inputFields.arquivos;
        filesList[idx]["file"] = target.files[0];
        setInputFields((inputFields) => ({
            ...inputFields, arquivos: filesList
        }));
    };

    const handleAddName = (target, idx) => {
        let filesList = inputFields.arquivos;
        filesList[idx]["field"] = target;
        setInputFields((inputFields) => ({
            ...inputFields, arquivos: filesList
        }));
    };

    return (
        <Container component="form"
            maxWidth="xg"
            sx={{ mt: 4, mb: 4 }}
            onSubmit={handleSubmit}>
            <Stack spacing={2} sx={{ width: '100%' }}>
                <Snackbar
                    open={open}
                    autoHideDuration={3000}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}>
                    <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                        {message}
                    </Alert>
                </Snackbar>
            </Stack>
            <Paper variant="outlined" sx={{ width: '100%', mb: 1 }}>
                <Box
                    sx={{
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        ml: 2,
                        mr: 2,
                        mb: 0
                    }}
                >
                    <Typography
                        sx={{ m: 2 }}
                        variant="h5"
                    >
                        Novo Acc
                    </Typography>
                </Box>
            </Paper>
            <Grid item xs={12}>
                <Paper variant="outlined" sx={{ my: { xs: 3, md: 0 }, p: { xs: 2, md: 3 } }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12}>
                            <Accordion expanded={true}>
                                <AccordionSummary expandIcon={false} id="panel-tel-header">
                                    <Typography>Informações do Contrato</Typography>

                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={3}>
                                            <FormControl fullWidth>
                                                <InputLabel id="select-label">Exportador</InputLabel>
                                                <Select
                                                    required
                                                    id="exportadora"
                                                    value={inputFields.exportadora}
                                                    label="Exportadora"
                                                    // InputProps={{ readOnly: running }}
                                                    onChange={event => setInputFields({ ...inputFields, exportadora: event.target.value })}
                                                    fullWidth
                                                >
                                                    {exporterList.map((field, idx) => {
                                                        return (
                                                            <MenuItem key={field.id} value={field.id}>{field.razaoSocial}</MenuItem>
                                                        )
                                                    })}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <FormControl fullWidth>
                                                <InputLabel id="select-label">Banco</InputLabel>
                                                <Select
                                                    required
                                                    id="banco"
                                                    value={inputFields.produto}
                                                    label="Banco"
                                                    // InputProps={{ readOnly: running }}
                                                    onChange={event => setInputFields({ ...inputFields, banco: event.target.value })}
                                                    fullWidth
                                                >
                                                    {bankList.map((field, idx) => {
                                                        return (
                                                            <MenuItem key={field.id} value={field.id}>{field.razaoSocial}</MenuItem>
                                                        )
                                                    })}

                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={2}>
                                            <TextField rows={3}
                                                required
                                                id="contratoBacen"
                                                name="contratoBacen"
                                                label="Contrato Bacen"
                                                fullWidth
                                                onChange={event => setInputFields({
                                                    ...inputFields, contratoBacen: event.target.value
                                                })}
                                                value={inputFields.contratoBacen}
                                                InputProps={{
                                                    inputComponent: ContractNumberMask
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={2}>
                                            <TextField rows={3}
                                                required
                                                id="contratoBanco"
                                                name="contratoBanco"
                                                label="Contrato Banco"
                                                fullWidth
                                                onChange={event => setInputFields({
                                                    ...inputFields, contratoBanco: event.target.value
                                                })}
                                                value={inputFields.contratoBanco}
                                                InputProps={{
                                                    inputComponent: ContractNumberMask
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={2}>
                                            <TextField
                                                required
                                                id="codigoMoeda"
                                                name="codigoMoeda"
                                                label="Código da moeda"
                                                fullWidth
                                                onChange={event => setInputFields({
                                                    ...inputFields, codigoMoeda: event.target.value
                                                })}
                                                value={inputFields.codigoMoeda}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <TextField rows={3}
                                                required
                                                id="contaDeposito"
                                                name="contaDeposito"
                                                label="Conta para Depósito"
                                                fullWidth
                                                onChange={event => setInputFields({
                                                    ...inputFields, contaDeposito: event.target.value
                                                })}
                                                value={inputFields.contaDeposito}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <TextField
                                                required
                                                id="naturezaOperacao"
                                                name="naturezaOperacao"
                                                label="Natureza da Operação"
                                                fullWidth
                                                onChange={event => setInputFields({
                                                    ...inputFields, naturezaOperacao: event.target.value
                                                })}
                                                value={inputFields.naturezaOperacao}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={2}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>

                                                <DatePicker
                                                    sx={{ width: '100%' }}
                                                    label="Data de Negociação"
                                                    defaultValue={todayStartOfTheDay}
                                                    maxDate={today}
                                                    value={inputFields.dataContrato}
                                                    format="DD/MM/YYYY"
                                                    onChange={event => setInputFields({
                                                        ...inputFields, dataContrato: event
                                                    })}
                                                />

                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={2}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>

                                                <DatePicker
                                                    sx={{ width: '100%' }}
                                                    label="Data de Crédito"
                                                    format="DD/MM/YYYY"
                                                    value={inputFields.dataCredito}
                                                    onChange={event => setInputFields({
                                                        ...inputFields, dataCredito: event
                                                    })}
                                                />

                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={2}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>

                                                <DatePicker
                                                    sx={{ width: '100%' }}
                                                    label="Data de Liquidação"
                                                    id="dataLiquidacao"
                                                    name="dataLiquidacao"
                                                    format="DD/MM/YYYY"
                                                    value={inputFields.dataLiquidacaoContrato}
                                                    onChange={event => setInputFields({
                                                        ...inputFields, dataLiquidacaoContrato: event
                                                    })}
                                                />

                                            </LocalizationProvider>
                                        </Grid>
                                        {/* <Grid item xs={12} sm={2}>
                                            <TextField
                                                required
                                                id="codigoEntregaMoeda"
                                                name="codigoEntregaMoeda"
                                                label="Código de Entrega"
                                                fullWidth
                                                onChange={event => setInputFields({
                                                    ...inputFields, codigoEntregaMoeda: event.target.value})}
                                                value={inputFields.codigoEntregaMoeda}
                                            />
                                        </Grid> */}
                                        <Grid item xs={12} sm={3}>
                                            <TextField
                                                required
                                                id="valorMonetarioDolar"
                                                name="valorMonetarioDolar"
                                                label="Total em Dólar"
                                                fullWidth
                                                onChange={event => setInputFields({
                                                    ...inputFields, valorMonetarioDolar: event.target.value,
                                                    valorMonetarioReal: inputFields.taxaCambial ? (realToFloat(event.target.value) * realToFloat(inputFields.taxaCambial)).toFixed(4) : 0
                                                })}
                                                value={inputFields.valorMonetarioDolar}
                                                InputProps={{
                                                    readOnly: running,
                                                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                    inputComponent: MoneyTextMask
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <TextField
                                                required
                                                id="taxaCambial"
                                                name="taxaCambial"
                                                label="Taxa Cambial"
                                                fullWidth
                                                onChange={event => setInputFields({
                                                    ...inputFields, taxaCambial: event.target.value,
                                                    valorMonetarioReal: inputFields.valorMonetarioDolar ? (realToFloat(inputFields.valorMonetarioDolar) * realToFloat(event.target.value)).toFixed(4) : 0
                                                })}
                                                value={inputFields.taxaCambial}
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                                                    inputComponent: MoneyTextMask4
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <TextField
                                                required
                                                id="valorMonetarioReal"
                                                name="valorMonetarioReal"
                                                label="Total em Reais"
                                                fullWidth
                                                value={inputFields.valorMonetarioReal}
                                                InputProps={{
                                                    readOnly: true,
                                                    startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <TextField
                                                required
                                                id="taxaJuros"
                                                name="taxaJuros"
                                                label="Taxa Juros"
                                                fullWidth
                                                onChange={event => setInputFields({
                                                    ...inputFields, taxaJuros: event.target.value,
                                                })}
                                                value={inputFields.taxaJuros}
                                                InputProps={{
                                                    endAdornment: <InputAdornment position="end">% A.A</InputAdornment>,
                                                    inputComponent: MoneyTextMask4
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <Accordion expanded={true}>
                                <AccordionSummary expandIcon={false} id="panel-tel-header">
                                    <Typography>Envio dos Arquivos</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={12}>
                                            <IconButton
                                                color="primary"
                                                aria-label="add file"
                                                size="small"
                                                onClick={() => {
                                                    let filesList = inputFields.arquivos;
                                                    filesList.push({ "field": "", "file": "" });
                                                    setInputFields({ ...inputFields, arquivos: filesList });
                                                }}
                                            >
                                                <Add />
                                            </IconButton>
                                            <IconButton
                                                sx={{ color: red[700] }}
                                                aria-label="rm file"
                                                size="small"
                                                onClick={() => {
                                                    if (inputFields.arquivos.length > 1) {
                                                        let filesList = inputFields.arquivos;
                                                        filesList.pop();
                                                        setInputFields({ ...inputFields, arquivos: filesList });
                                                    }
                                                }}
                                            >
                                                <Remove />
                                            </IconButton>
                                        </Grid>
                                        {inputFields.arquivos.map((field, idx) => {
                                            return (
                                                <React.Fragment key={idx}>
                                                    <Grid item xs={12} sm={3}>
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            disabled={running}
                                                            id={`${idx + 1}`}
                                                            name="filename"
                                                            label={`Arquivo ${idx + 1}`}
                                                            value={inputFields.arquivos[idx]["field"]}
                                                            onChange={event => handleAddName(event.target.value, idx)}
                                                            // InputProps={{
                                                            //     inputComponent: TelTextMask
                                                            // }}
                                                            // fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={3}>
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            disabled={running}
                                                            id={`${idx + 1}`}
                                                            name="arquivo"
                                                            label={`Arquivo ${idx + 1}`}
                                                            value={inputFields.arquivos[idx]["file"].name}
                                                            InputLabelProps={{ shrink: true }}
                                                            InputProps={{
                                                                readOnly: true,
                                                                endAdornment:
                                                                    <Button
                                                                        size="small"
                                                                        component="label"
                                                                        color="primary"
                                                                        variant="outlined">
                                                                        <input
                                                                            hidden
                                                                            accept="pdf/*"
                                                                            multiple
                                                                            type="file"
                                                                            onChange={event => handleAddFile(event.target, idx)}
                                                                        >
                                                                        </input>
                                                                        <UploadFileIcon />
                                                                    </Button>
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}></Grid>
                                                </React.Fragment>
                                            )
                                        })}
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <Grid container>
                                <LoadingButton
                                    loading={running}
                                    type="submit"
                                    startIcon={(<SaveIcon />)}
                                    color="primary"
                                    variant="contained"
                                    size="medium"
                                    disableElevation
                                    sx={{ width: "200px" }}
                                >
                                    Salvar
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Container>
    );
}
